export enum LendiCareProductType {
  COMMUNICATION = 'LendiCareCommunication',
  REAL_ESTATE = 'LendiCareRealEstate',
  LIFE = 'LendiCareLife',
  COMPANY = 'LendiCareCompany',
  TRAVEL = 'LendiCareTravel',
  INVESTMENT = 'LendiCareInvestment'
}
